import { render, staticRenderFns } from "./surface_title.vue?vue&type=template&id=bcbe642c&scoped=true&"
import script from "./surface_title.vue?vue&type=script&lang=js&"
export * from "./surface_title.vue?vue&type=script&lang=js&"
import style0 from "./surface_title.vue?vue&type=style&index=0&id=bcbe642c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbe642c",
  null
  
)

export default component.exports